import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { extractionListSearchSchema } from "@client/components/doc-center/extraction-task/extraction-list-state";
import { ExtractionTaskListPage } from "@client/components/doc-center/extraction-task/extraction-task-list-page";
import type { ExtractionTaskListFiltersState } from "@client/components/doc-center/extraction-task/extraction-task-list-filters";

export const Route = createFileRoute("/_app/data-center/extraction/")({
  validateSearch: extractionListSearchSchema,
  component: ExtractionTaskListPageWrapper,
});

function ExtractionTaskListPageWrapper() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleSearchChange = useCallback(
    (next: Partial<ExtractionTaskListFiltersState>) =>
      navigate({
        to: "/data-center/extraction",
        search: (prev) => {
          const merged = { ...prev, ...next };
          return {
            fileId: merged.fileId,
            fileIds: merged.fileIds,
            search: merged.search,
            extractMode: merged.extractMode,
            tmplId: merged.tmplId,
            status: merged.status,
            scope: merged.scope,
            page: typeof merged.page === "number" ? merged.page : undefined,
            pageSize: typeof merged.pageSize === "number" ? merged.pageSize : undefined,
          };
        },
        replace: true,
      }),
    [navigate],
  );

  return (
    <ExtractionTaskListPage
      filters={search}
      onFiltersChange={handleSearchChange}
    />
  );
}
